
import { NavigateOptions, useNavigate } from 'react-router-dom'
import { useAuth } from '../features/auth/hooks'
import { userRoles } from '../features/user/types/user.types'
import useQueryURL from '../common/hooks/useQueryURL'
import { SINGLE_CHARGE_SESSION_MODAL_ID } from '../pages/ChargingSessionPage/SingleChargingSessionPage/SingleChargingSessionPage'
import { SINGLE_TRANSACTION_MODAL_ID } from '../pages/TransactionPages/SingleTransactionPage/SingleTransactionPage'
import { EDIT_CONNECTOR_MODAL_ID } from '../pages/StationPages/EditConnectorPage/EditConnectorPage'

export default function useNavigationApp() {
    const navigate = useNavigate()

    const {userRole} = useAuth()

    const {setQueryValue} = useQueryURL()


    const redirectToLoginPage = () => {
 
            navigate('/login')
        
    }

    const getBaseURL = () : string => {
        switch (userRole) {
            case userRoles.ADMIN:
                return '/admin'
            case userRoles.SUPER_ADMIN:
                return '/sup-admin'
            case userRoles.USER:
                return '/user'
        }

        return '/'
    }

    const baseURL = getBaseURL()
    const goToHome = () => {
        navigate(baseURL)
    }


    const goToStationList = () => {
        navigate(`${baseURL}/stations`)
    }

    const goToSingleStation = (id?: string) => {
        navigate(`${baseURL}/stations/${id}`)
    }

    const goToCreateNewStation = () => {
        navigate(`${baseURL}/stations?modal_add_station=true`)
    }

    const goToSingleChargePoint = (stationId?: string, chargePointid?: string) => {
        navigate(`${baseURL}/stations/${stationId}?chargePointId=${chargePointid}&singleChargePoint=true`)
    }

    const goToSingleConnector = (stationId?: string, chargePointId?: string, connectorId?: string,option?: {keepURL?: boolean}) => {

        if (option?.keepURL){
            setQueryValue({
                ["connectorId"]: connectorId || "test", //eslint-disable-line
                ["single-connector-modal"]: "true", //eslint-disable-line
                ["chargePointId"]: chargePointId || "test", //eslint-disable-line
                ["stationId"]: stationId || "test", //eslint-disable-line
                ["singleChargePoint"]: "true", //eslint-disable-line
            })
            return
        }
        navigate(`${baseURL}/stations/${stationId}?chargePointId=${chargePointId}&connectorId=${connectorId}&singleChargePoint=true&single-connector-modal=true&single-connector-id=${connectorId}`)
    }

    const goToOrganizationList = () => {
        navigate(`${baseURL}/organizations`)
    }
    const goToSingleOrganization = (id?: string) => {
        navigate(`${baseURL}/organizations/${id}`)
    }

    const goToNewPayGo = () => {
        navigate(`${baseURL}/paygos?new-paygo-modal=true`)
    }

    const goToSinglePayGo = (id: string,option?:{keepURL?: boolean}) => {
        const modalId = "single-paygo-modal"

        if (option?.keepURL){
            setQueryValue({
                paygoId: id,
               [modalId]: "true"
            })
            return 
        }
        navigate(`${baseURL}/paygos?paygoId=${id}&single-paygo-modal=true`)
    }

    const goToNewHardware = () => {
        navigate(`${baseURL}/hardwares?addNewHardwareModal=true`)
    }

    const goToCreatUserInvitationLink = () => {
        navigate(`${baseURL}/users/invitations?modal_add_user_link=true`)
    }

    const goToSingleUserInvitationLink = (id: string, option?: {keepURL?: boolean}) => {
        const modalId = "single-culk-modal"
        const paramId = "single-culk-modal-id"

        if (option?.keepURL){
            setQueryValue({
                [paramId]: id,
               [modalId]: "true"
            })
            return 
        }
        navigate(`${baseURL}/users/invitations?single-culk-modal=true&single-culk-modal-id=${id}`)
    }

    const goToUserList = () => {
        navigate(`${baseURL}/users`)
    }
    const goToSingleUser = (id: string, optionNav?:NavigateOptions ) => {
        navigate(`${baseURL}/users/${id}`, optionNav)
    }

    const goToSingleUserExtend = (idUserOrga: string, optionNav?:NavigateOptions ) => {
        navigate(`${baseURL}/users/${idUserOrga}`, optionNav)
    }

    const goToEditUser = (id: string) => {
        navigate(`${baseURL}/users/${id}?edit-user-modale=true`)
    }

    const goToClientList = () => {
        navigate(`${baseURL}/clients`)
    }

    const goToSingleClient = (id: string) => {
        navigate(`${baseURL}/clients/${id}`)
    }

    const goToClientWallet = (userOrgaId: string, idWallet: string) => {
        navigate(`${baseURL}/client-extends/${userOrgaId}/wallets/${idWallet}`)
    }

    const goToSingleTransaction = (id: string, relatifPath?: boolean) => {

        const base = relatifPath ? "" : baseURL+"/transactions"

        if (relatifPath){
            setQueryValue({
                transactionId: id,
                [SINGLE_TRANSACTION_MODAL_ID]: "true"
            })
            return
        }else{
            navigate(`${base}?${SINGLE_TRANSACTION_MODAL_ID}=true&transactionId=${id}`)
        }
     
    }

    
    
    const goAddCreditWallet = (idClient: string, idWallet: string) => {
        navigate(`${baseURL}/client-extends/${idClient}/wallets/${idWallet}?add-credit-modal=true`)
    }

    const goToSingleClientExtend = (userOrgaId: string) => {
        navigate(`${baseURL}/client-extends/${userOrgaId}`)
    }

    const goChargingSessionList = () => {
        navigate(`${baseURL}/charging-sessions`)
    }

    const goToSingleChargingSession = (id: string, relatifPath?: boolean) => {
        
        
        const base = relatifPath ? "" : baseURL+"/charging-sessions"

        if (relatifPath){
            setQueryValue({
                chargingSessionId: id,
                [SINGLE_CHARGE_SESSION_MODAL_ID]: "true"
            })
            return
        }else{
            navigate(`${base}?${SINGLE_CHARGE_SESSION_MODAL_ID}=true&chargingSessionId=${id}`)
        }
    }

    const goToWalletOrgnization = (idOrg: string, idWallet: string) => {
        navigate(`${baseURL}/organizations/${idOrg}/wallet/${idWallet}`)
    }


    const goTo = (path: string, options?: NavigateOptions) => {
        if (path.startsWith("/")) {
            navigate(path, options)
        } else {
            navigate(`${baseURL}/${path}`, options)
        }
    }

    const goToEditConnector = (options?: {
        stationId?: string,
        chargePointId?: string,
        connectorId?: string,
        relatifPath?: boolean
    }) => {
        if (options?.relatifPath){
            setQueryValue({
                ["single-connector-id"]: options?.connectorId || "test", //eslint-disable-line
                [EDIT_CONNECTOR_MODAL_ID]: "true"
            })
            return
        }else{
            navigate(`${baseURL}/stations/${options?.stationId}?chargePointId=${options?.chargePointId}&single-connector-id=${options?.connectorId}&${EDIT_CONNECTOR_MODAL_ID}=true`)
        }
    }

  return {

    goToHome,
    goToStationList,
    goToSingleStation,
    goToCreateNewStation,
    goToSingleChargePoint,
    goToSingleConnector,
    goToOrganizationList,
    goToSingleOrganization,
    goToNewPayGo,
    goToSinglePayGo,
    goToNewHardware,
    goToCreatUserInvitationLink,
    goToSingleUserInvitationLink,
    goToUserList,
    goToSingleUser,
    goToEditUser,
    redirectToLoginPage,
    goToClientList,
    goToSingleClient,
    goToClientWallet,
    goToSingleTransaction,
    goAddCreditWallet,
    goToSingleUserExtend,
    goToSingleClientExtend,
    goToSingleChargingSession,
    goChargingSessionList,
    goToWalletOrgnization,
    goToEditConnector,
    goTo

  } 
}
